import * as reportReceiptActions from './actions';
import {Record, fromJS, Map} from 'immutable';
import {manageReceipts} from '../../lib/util';

const State = Record({
    page: 0,
    limit: 8,
    receipts: Map(),
    max: 0,
    reportReceiptToPrint: null,
    vats: null
});

const PAGE = 'page';
const RECEIPTS = 'receipts';
const MAX = 'max';
const VATS = 'vats';

const reportReceiptReducer = (state = new State(), action) => {

    switch (action.type) {

        case reportReceiptActions.FETCH_BAR_REPORT_RECEIPTS_ERROR:
        case reportReceiptActions.CLEAR_BAR_REPORT_RECEIPTS: {
            return state
                .set(PAGE, 0)
                .set(RECEIPTS, Map())
                .set(MAX, 0);
        }

        case reportReceiptActions.FETCH_BAR_REPORT_RECEIPTS_START: {
            const {vats} = action.payload;
            return state.set(VATS, vats);
        }

        case reportReceiptActions.FETCH_BAR_REPORT_RECEIPTS_SUCCESS: {
            const {page, receipts, max} = action.payload.data;
            return state
                .set(PAGE, page)
                .set(RECEIPTS, manageReceipts(fromJS(receipts), state.get(VATS)))
                .set(MAX, max);
        }

    }

    return state;
};

export default reportReceiptReducer;




// WEBPACK FOOTER //
// ./src/common/report/receipt/reducer.js